export default __webpack_public_path__ + "static/media/tagagot-screenshot-03.1b48022d.png";